export default "__VITE_ASSET__ED$BnwP___"